<template>
  <v-container>
    <alerts
      module="orderHistory"
    />

    <h2 class="mt-5 mb-5">Order History</h2>

    <v-skeleton-loader v-if="loading" type="table-tbody" />

    <v-expansion-panels v-else>
      <v-expansion-panel
        v-for="(order,index) in orders"
        :key="index"
      >
        <v-expansion-panel-header>
          <div class="d-flex">
            <div class="d-flex justify-space-between mr-2" style="min-width: 96px;">
              <span>Order:</span><span>#{{ order.orderNumber }}</span>
            </div>
            <div>{{ formatDate(order.createdAt) }}</div>
            <div class="d-flex flex-grow-1">
              <div class="spacer"></div>
              <div class="mx-1">{{ status(order) }}</div>
              <div class="mx-2 font-weight-bold">
                ${{ order.totalPrice === 0 ? 'FREE' : order.totalPrice }}
              </div>
            </div>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-simple-table v-if="order.lineItems" light>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left"> Product </th>
                  <th class="text-left"> Quantity </th>
                  <th class="text-left"> Total </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in order.lineItems"
                  :key="item.title"
                >
                  <td>{{ item.title }}</td>
                  <td>{{ item.quantity }}</td>
                  <td>${{ item.price }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'OrderHistory',
  methods: {
    status: function (order) {
      let ret = '';
      if (order.fulfillmentStatus) {
        ret += this.capitalizeFirstLetter(order.fulfillmentStatus);
      } else {
        ret += 'Unfulfilled';
      }

      if (order.financialStatus) {
        ret += '/' + this.capitalizeFirstLetter(order.financialStatus);
      }
      return ret;
    },
    capitalizeFirstLetter: function (string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    formatDate: function (date) {
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return new Date(date).toLocaleDateString(undefined, options);
    }
  },
  computed: {
    ...mapState('orderHistory', {
      orders: state => state.data,
      loading: state => state.loading
    })
  },
  created: function () {
    this.$store.dispatch('orderHistory/getOrders');
  }
};
</script>
